/* ============================================================
   Larkporch — theme.js
   AJAX cart drawer · gallery · accordions · sticky add-to-cart
   Vanilla JS, no dependencies. See docs/ARCHITECTURE.md §4.
   ============================================================ */
(function () {
  'use strict';

  var routes = window.themeRoutes || {};
  var strings = window.themeStrings || {};
  var shopCurrency = window.shopCurrency || 'USD';
  var shopLocale = window.shopLocale || 'en';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function money(cents) {
    try {
      return new Intl.NumberFormat(shopLocale, { style: 'currency', currency: shopCurrency }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- body scroll lock ---------- */
  var lockedScrollY = 0;
  function lockScroll(on) {
    if (on) {
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.top = -lockedScrollY + 'px';
      document.body.classList.add('drawer-open');
    } else {
      var de = document.documentElement;
      var prevBehavior = de.style.scrollBehavior;
      de.style.scrollBehavior = 'auto';
      document.body.classList.remove('drawer-open');
      document.body.style.top = '';
      window.scrollTo(0, lockedScrollY);
      de.style.scrollBehavior = prevBehavior;
    }
  }

  /* ---------- drawers ---------- */
  var overlay = $('#Overlay');

  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    lockScroll(true);
    var focusable = el.querySelector('button, a, input');
    if (focusable) focusable.focus({ preventScroll: true });
  }
  function closeDrawers() {
    var wasOpen = false;
    $all('.drawer').forEach(function (d) {
      if (d.classList.contains('is-open')) wasOpen = true;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    if (overlay) overlay.classList.remove('is-open');
    if (wasOpen) lockScroll(false);
  }

  if (overlay) overlay.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  document.addEventListener('click', function (e) {
    var openT = e.target.closest('[data-drawer-open]');
    if (openT) {
      e.preventDefault();
      var target = $('#' + openT.getAttribute('data-drawer-open'));
      if (target && target.id === 'CartDrawer') refreshCart();
      openDrawer(target);
    }
    var closeT = e.target.closest('[data-drawer-close]');
    if (closeT) {
      var isLink = closeT.tagName === 'A' && closeT.getAttribute('href');
      if (!isLink) e.preventDefault();
      closeDrawers();
    }
  });

  /* ---------- cart ---------- */
  var cartBody = $('#CartDrawerBody');
  var cartFoot = $('#CartDrawerFoot');

  function updateBubble(count) {
    $all('[data-cart-count]').forEach(function (b) {
      b.textContent = count;
      b.classList.toggle('is-visible', count > 0);
    });
  }

  /* ---------- free-shipping progress bar (drawer + cart page) ---------- */
  function updateShippingProgress(cart) {
    try {
      var threshold = window.freeShippingThreshold;
      $all('[data-cart-progress]').forEach(function (el) {
        if (!threshold || !cart.item_count) { el.hidden = true; return; }
        var subtotal = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
        var unlocked = subtotal >= threshold;
        var pct = Math.max(0, Math.min(100, Math.round((subtotal / threshold) * 100)));
        el.hidden = false;
        el.classList.toggle('is-unlocked', unlocked);
        var fill = el.querySelector('[data-cart-progress-fill]');
        if (fill) fill.style.width = pct + '%';
        var msg = el.querySelector('[data-cart-progress-msg]');
        if (msg) {
          msg.textContent = unlocked
            ? (strings.progressUnlocked || '')
            : (strings.progressFree || '').replace('[amount]', money(threshold - subtotal));
        }
      });
    } catch (err) { /* never let the progress bar block cart rendering */ }
  }

  function renderCart(cart) {
    updateBubble(cart.item_count);
    updateShippingProgress(cart);
    if (!cartBody) return cart;
    cartBody.classList.add('is-fading');

    if (!cart.item_count) {
      cartBody.innerHTML =
        '<div class="cart-empty">' +
        '<p class="h3">' + escapeHtml(cartBody.getAttribute('data-empty') || '') + '</p>' +
        '<button class="btn btn--primary" style="margin-top:1.6rem" data-drawer-close>' +
        escapeHtml(cartBody.getAttribute('data-empty-cta') || '') + '</button></div>';
      if (cartFoot) cartFoot.hidden = true;
      requestAnimationFrame(function () { cartBody.classList.remove('is-fading'); });
      return cart;
    }
    if (cartFoot) cartFoot.hidden = false;

    var removeLabel = cartBody.getAttribute('data-remove') || '';
    var html = cart.items.map(function (item, i) {
      var line = i + 1;
      var variant = (item.product_has_only_default_variant) ? '' :
        '<div class="ci-variant">' + escapeHtml(item.options_with_values.map(function (o) { return o.value; }).join(' · ')) + '</div>';
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
      var priceHtml = (item.original_line_price > item.final_line_price)
        ? money(item.final_line_price) + ' <s>' + money(item.original_line_price) + '</s>'
        : money(item.final_line_price);
      return '' +
        '<div class="cart-item" data-line="' + line + '">' +
          '<a href="' + escapeHtml(item.url) + '">' + (img ? '<img src="' + escapeHtml(img) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="ci-thumb"></span>') + '</a>' +
          '<div class="ci-meta">' +
            '<a href="' + escapeHtml(item.url) + '" class="ci-title">' + escapeHtml(item.product_title) + '</a>' +
            variant +
            '<div class="ci-price">' + priceHtml + '</div>' +
          '</div>' +
          '<div class="ci-controls">' +
            '<div class="qty">' +
              '<button type="button" data-line-change="' + line + '" data-dir="-1" aria-label="' + escapeHtml(strings.decrease || '-') + '">&minus;</button>' +
              '<input type="text" value="' + item.quantity + '" readonly aria-label="' + escapeHtml(strings.quantity || 'qty') + '">' +
              '<button type="button" data-line-change="' + line + '" data-dir="1" aria-label="' + escapeHtml(strings.increase || '+') + '">+</button>' +
            '</div>' +
            '<button class="ci-remove" data-line-change="' + line + '" data-set="0">' + escapeHtml(removeLabel) + '</button>' +
          '</div>' +
        '</div>';
    }).join('');
    cartBody.innerHTML = html;
    requestAnimationFrame(function () { cartBody.classList.remove('is-fading'); });

    var sub = $('#CartSubtotal');
    if (sub) sub.textContent = money(cart.total_price);
    return cart;
  }

  function refreshCart() {
    return fetch((routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return cart;
      })
      .catch(function () {});
  }

  function changeLine(line, qty) {
    return fetch((routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      renderCart(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    var line = parseInt(btn.getAttribute('data-line-change'), 10);
    var item = btn.closest('.cart-item');
    if (btn.hasAttribute('data-set')) {
      changeLine(line, parseInt(btn.getAttribute('data-set'), 10));
      return;
    }
    var input = item.querySelector('input');
    var current = parseInt(input.value, 10) || 1;
    var next = Math.max(0, current + parseInt(btn.getAttribute('data-dir'), 10));
    changeLine(line, next);
  });

  /* ---------- add to cart (product forms) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btns = $all('[type="submit"]', form).concat($all('button[form="' + form.id + '"]'));
    var originals = btns.map(function (b) { return b.innerHTML; });
    var status = form.querySelector('[data-form-status]');
    if (status) { status.hidden = true; status.textContent = ''; }
    btns.forEach(function (b) { b.disabled = true; b.classList.add('is-loading'); b.innerHTML = strings.adding || '…'; });

    var fd = new FormData(form);
    var variantId = fd.get('id');
    var quantity = parseInt(fd.get('quantity'), 10) || 1;

    fetch((routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (added) {
        document.dispatchEvent(new CustomEvent('cart:added', { detail: {
          variantId: variantId, quantity: quantity,
          price: added && added.price, title: added && added.product_title, variantTitle: added && added.variant_title,
          productId: added && added.product_id
        } }));
        return refreshCart();
      })
      .then(function () {
        btns.forEach(function (b) { b.innerHTML = strings.added || '✓'; });
        openDrawer($('#CartDrawer'));
        setTimeout(function () {
          btns.forEach(function (b, i) { b.disabled = false; b.classList.remove('is-loading'); b.innerHTML = originals[i]; });
        }, 1200);
      })
      .catch(function (err) {
        if (status) { status.hidden = false; status.textContent = (err && err.description) || strings.error || 'Error'; }
        btns.forEach(function (b, i) { b.disabled = false; b.classList.remove('is-loading'); b.innerHTML = originals[i]; });
      });
  });

  /* ---------- qty steppers ([data-qty] wrapper) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty] button');
    if (!b) return;
    var wrap = b.closest('[data-qty]');
    var input = wrap.querySelector('input');
    if (!input) return;
    var dir = parseInt(b.getAttribute('data-dir'), 10) || 0;
    var min = parseInt(input.min, 10) || 1;
    var v = Math.max(min, (parseInt(input.value, 10) || min) + dir);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- gallery (swipeable track + thumb sync) ---------- */
  $all('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-gallery-track]');
    var slides = track ? $all('[data-gallery-slide]', track) : [];
    var thumbs = $all('[data-thumb]', g);
    if (!track || slides.length < 2) return;

    /* slide pitch = width + the flex gap (slides are 100% wide) */
    function stepSize() { return (slides[1].offsetLeft - slides[0].offsetLeft) || track.clientWidth; }

    function setActive(i) {
      thumbs.forEach(function (t, ti) {
        t.classList.toggle('is-active', ti === i);
        t.setAttribute('aria-current', ti === i ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-index'), 10) || 0;
        track.scrollTo({ left: i * stepSize(), behavior: reduceMotion ? 'auto' : 'smooth' });
        setActive(i);
      });
    });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        setActive(Math.round(track.scrollLeft / stepSize()));
      }, 80);
    }, { passive: true });
  });

  /* ---------- pack tier selector (product__tier radios) ---------- */
  $all('.product').forEach(function (root) {
    try {
      var form = root.querySelector('form[data-product-form]');
      var radios = $all('[data-tier-radio]', root);
      if (!radios.length) return;

      var applyTier = function (radio) {
        try {
          radios.forEach(function (r) {
            var l = r.closest('label');
            if (l) l.classList.toggle('is-selected', r === radio);
          });
          if (form) {
            var idInput = form.querySelector('[data-variant-id]');
            if (idInput) idInput.value = radio.value;
          }
          var d = radio.dataset;
          $all('[data-price]', root).forEach(function (pr) {
            var cur = pr.querySelector('.price__current');
            if (cur && d.price) cur.textContent = d.price;
            var cmp = pr.querySelector('.price__compare');
            var bdg = pr.querySelector('.price__badge');
            var onSale = !!d.compare;
            if (cmp) { cmp.hidden = !onSale; if (onSale) cmp.textContent = d.compare; }
            if (bdg) bdg.hidden = !onSale;
            pr.classList.toggle('price--on-sale', onSale);
          });
          var available = d.available !== 'false';
          $all('[data-buy-button]', root).forEach(function (b) {
            b.disabled = !available;
            var label = b.querySelector('.buy-buttons__label');
            if (label) label.textContent = available ? (strings.addToCart || label.textContent) : (strings.soldOut || label.textContent);
          });
        } catch (err) { /* never let a tier-selection bug block anything else on the page */ }
      };

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () { applyTier(radio); });
      });
      var checked = root.querySelector('[data-tier-radio]:checked') || root.querySelector('[data-tier-radio][data-default]:not(:disabled)') || radios[0];
      if (checked) { checked.checked = true; applyTier(checked); }
    } catch (err) { /* same: isolate failures per product root */ }
  });

  /* ---------- animated accordions (<details class="accordion">) ---------- */
  $all('.accordion').forEach(function (details) {
    var summary = details.querySelector('summary');
    var body = details.querySelector('.accordion__body');
    if (!summary || !body || reduceMotion || !details.animate) return;

    var anim = null, closing = false, expanding = false;

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      details.style.overflow = 'hidden';
      if (closing || !details.open) openAndExpand();
      else if (expanding || details.open) shrink();
    });

    function shrink() {
      closing = true;
      var startHeight = details.offsetHeight + 'px';
      var endHeight = summary.offsetHeight + 'px';
      if (anim) anim.cancel();
      anim = details.animate({ height: [startHeight, endHeight] }, { duration: 220, easing: 'ease-out' });
      body.animate({ opacity: [1, 0] }, { duration: 150, easing: 'ease-out' });
      anim.onfinish = function () { onFinish(false); };
      anim.oncancel = function () { closing = false; };
    }
    function openAndExpand() {
      details.style.height = details.offsetHeight + 'px';
      details.open = true;
      window.requestAnimationFrame(expand);
    }
    function expand() {
      expanding = true;
      var startHeight = details.offsetHeight + 'px';
      var endHeight = summary.offsetHeight + body.offsetHeight + 'px';
      if (anim) anim.cancel();
      anim = details.animate({ height: [startHeight, endHeight] }, { duration: 220, easing: 'ease-out' });
      body.animate({ opacity: [0, 1] }, { duration: 220, easing: 'ease-out' });
      anim.onfinish = function () { onFinish(true); };
      anim.oncancel = function () { expanding = false; };
    }
    function onFinish(open) {
      details.open = open;
      anim = null; closing = false; expanding = false;
      details.style.height = '';
      details.style.overflow = '';
    }
  });

  /* ---------- sticky header shadow ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('header--scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- sticky add-to-cart (mobile bar, appears once the buy box scrolls out) ---------- */
  var stickyAtc = $('[data-sticky-atc]');
  var buyAnchor = $('[data-buy-actions]');
  if (stickyAtc && buyAnchor && 'IntersectionObserver' in window) {
    var atcIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyAtc.classList.toggle('is-visible', show);
        stickyAtc.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { threshold: 0 });
    atcIO.observe(buyAnchor);
  }

  // initial cart bubble
  refreshCart();
})();
